import { render, staticRenderFns } from "./TradeNegotiations.vue?vue&type=template&id=2f8af259&scoped=true&"
import script from "./TradeNegotiations.vue?vue&type=script&lang=js&"
export * from "./TradeNegotiations.vue?vue&type=script&lang=js&"
import style0 from "./TradeNegotiations.vue?vue&type=style&index=0&id=2f8af259&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8af259",
  null
  
)

export default component.exports